export enum PageKey {
  LOGIN = 'login',
  DONATION = 'donation'
}
